<template>
  <nav class="hero-nav">
    <!-- Left Links -->
    <div class="nav-section left-links">
      <ul>
        <li>
          <NavLink>
            <router-link to="/" exact-active-class="active">Home</router-link>
          </NavLink>
        </li>
        <li>
          <NavLink>
            <router-link to="/team" exact-active-class="active">Meet the Team</router-link>
          </NavLink>
        </li>
        <li>
          <NavLink>
            <router-link to="/locations" exact-active-class="active">Locations</router-link>
          </NavLink>
        </li>
      </ul>
    </div>

    <!-- Logo Section -->
    <div class="nav-section logo">
      <NavLink>
        <router-link to="/">
          <img src="@/assets/images/logo-empire-oc-black.png" alt="Logo" />
        </router-link>
      </NavLink>
    </div>

    <!-- Right Links -->
    <div class="nav-section right-links">
      <ul>
        <li>
          <NavLink>
            <router-link to="/buena-park" exact-active-class="active">Buena Park</router-link>
          </NavLink>
        </li>
        <li>
          <NavLink>
            <router-link to="/irvine" exact-active-class="active">Irvine</router-link>
          </NavLink>
        </li>
        <li>
          <NavLink>
            <ButtonLink 
              text="Free Trial"
              url="/free-trial"
              color="white"
            />
          </NavLink>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  import ButtonLink from '../Common/ButtonLink.vue'
  import NavLink from '../Common/NavLink.vue'

  export default {
    name: "HeroLinks",
    components: {
      ButtonLink,
      NavLink
    }
  };
</script>

<style scoped>
  .hero-nav {
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background-color: transparent;
    z-index: 100;
    box-sizing: border-box;
  }

  .nav-section {
    display: flex;
    align-items: center;
  }

  .nav-section ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 20px;
  }

  .nav-section.logo img {
    height: 50px;
    object-fit: contain;
  }

  .hero-nav a {
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s ease;
  }

  .hero-nav a:hover {
    color: #FFE54F;
  }

  /* Active State */
  .hero-nav a.active {
    color: #FFE54F !important;
  }

  /* Responsive Styles */
  @media (max-width: 768px) {
    .hero-nav {
      flex-direction: column;
      align-items: center;
      padding: 10px 0;
    }

    .nav-section {
      justify-content: center;
      margin-bottom: 10px;
      width: 100%;
    }

    .nav-section.left-links {
      margin-left: 0;
      padding-left: 0;
    }

    .nav-section.logo {
      order: -1;
      margin-bottom: 20px;
    }

    .nav-section ul {
      flex-direction: column;
      gap: 10px;
      align-items: center;
      width: 100%;
      padding: 0;
    }

    .nav-section.logo img {
      height: 90px;
    }
  }
</style>
